import type { CarbonLayerOption } from '../../../../../../../core/models/metadata';

export const AVAILABLE_CARBON_LAYERS: CarbonLayerOption[] = [
  {
    value: 'Environment-Soil-Carbon-Actual-Percent-OM-Static-AR-Aapresid-v2',
    type: 'organic_matter',
  },
  {
    value: 'Environment-Soil-Carbon-Actual-Tonne-Static-AR-Aapresid-v2',
    type: 'carbon_in_tonnes',
  },
  {
    value: 'Environment-Soil-Carbon-Potential-Percent-OM-Static-AR-Aapresid-v2',
    type: 'potencial_organic_matter',
  },
  {
    value: 'Environment-Soil-Carbon-Potential-Tonne-Static-AR-Aapresid-v2',
    type: 'potencial_carbon_in_tonnes',
  },
  {
    value: 'Environment-Soil-Carbon-Reachable-Percent-OM-Static-AR-Aapresid-v2',
    type: 'reachable_carbon_in_tonnes',
  },
  {
    value: 'Environment-Soil-Carbon-Reachable-Tonne-Static-AR-Aapresid-v2',
    type: 'reachble_organic_matter',
  },
];
